import { render, staticRenderFns } from "./dt-picker1.vue?vue&type=template&id=56966d9e&"
import script from "./dt-picker1.vue?vue&type=script&lang=ts&"
export * from "./dt-picker1.vue?vue&type=script&lang=ts&"
import style0 from "./dt-picker1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports